<template>
	<div :class="classes">
		<!-- User details -->
		<p v-if="!leftAlign" class="user__name user__name--left">{{ user }}</p>
		<div class="user__icon">
			<IconAccount :class="{ invert }" />
		</div>
		<p v-if="leftAlign" class="user__name user__name--right">{{ user }}</p>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import IconAccount from 'mdi-vue/Account'

export default {
	name: 'user',
	props: {
		align: {
			type: String,
			default: 'left',
			validator: v => ['left', 'right'].includes(v)
		},
		invert: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		...mapGetters({ user: 'auth/username' }),
		leftAlign() {
			return this.align === 'left'
		},
		classes() {
			return ['user', { 'user--invert': this.invert }]
		}
	},
	components: {
		IconAccount
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/layout';
@import '~scss/components';
@import '~scss/mq';

.user {
	@extend %flex-center;
	position: relative;

	&__icon {
		@include square(1.875rem);
	}

	&__name {
		&--left {
			margin-right: 0.5rem;
		}
		&--right {
			margin-left: 0.5rem;
		}
	}

	&--invert {
		color: $white;
	}

	&__menu {
		display: none;
		pointer-events: none;
		opacity: 0;
		position: absolute;
		top: 100%;
		right: -0.5rem;
		transform: translateY(-1rem);

		$anim: 0.25s $ease-out-sine;
		transition: opacity $anim, transform $anim;
	}
	&:hover &__menu {
		pointer-events: all;
		opacity: 1;
		transform: none;
	}

	@include mq(md) {
		&__menu {
			display: block;
		}
	}
}
</style>
